var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTooltip)?_c('div',{ref:"tooltip",staticClass:"tooltip",style:({
    top: _vm.positionTop,
    left: _vm.positionLeft,
  })},[_c('div',{staticClass:"tooltip-inner"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.body))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }